// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"56d6dbad","515":"2a1555f6","588":"dfbb6c7b","593":"90fac7d1","797":"eab38915"}[chunkId] + ".chunk.js";
};